
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false,
    unassignedPhotoCount: {
      type: Number,
      default: 0
    }
  }
};
